module.exports = __webpack_public_path__ + "static/assets/e75c65e1679e0cc2800caa5c47823daa.mp3";